import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Supabase Functions URL
export const SUPABASE_FUNCTIONS_URL = process.env.REACT_APP_SUPABASE_FUNCTIONS_URL;
